export const pluralize = (count: number, singular: string, plural: string) =>
  count === 1 ? singular : plural;

export const getRandomString = (length: number) => {
  return Math.random()
    .toString(36)
    .substring(2, Math.max(0, length) + 2);
};
